import React from 'react'
import {
  PixelButton,
  PixelCurrency,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  SectionTitle,
} from 'pixel-base'
import styled from 'styled-components'

import { post } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const GeneralInfo = (props) => {
  const { customer } = props
  const tenantData = JSON.parse(localStorage.getItem('tenant_info') || '{}')
  const tenant = tenantData.tenant_id
  const { showFailure, showSuccess } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [customerInfo, setCustomerInfo] = React.useState<any>(customer)

  React.useEffect(() => {
    setCustomerInfo(customer)
  }, [customer])

  const linkWithStripe = () => {
    // showPageLoader()
    post(`/link-stripe-customer/${customer.customer_id}`, null).subscribe(
      (res) => {
        // hidePageLoader()
        if (res.response && res.response?.stripe_customer_id) {
          setCustomerInfo({
            ...customerInfo,
            stripe_customer_id: res.response.stripe_customer_id,
          })
          showSuccess('Customer linked with stripe successfully')
        } else if (res.response.error === 'Customer already Created') {
          showSuccess('Customer already Created')
        } else {
          showFailure('Something went wrong')
        }
      },
    )
  }

  const style = {
    fontSize: '16px',
    fontWeight: '400',
    color: '#8e959b',
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingLeft: '10px',
  }
  return (
    <>
      <PixelFlexBox flexDirection="column">
        <SectionTitle>Primary Contact</SectionTitle>
        <InfoItem>
          <Label>FIRST NAME:</Label>
          <PixelDiv style={style}>{customerInfo?.first_name || '--'}</PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>LAST NAME:</Label>
          <PixelDiv style={style}>{customerInfo?.last_name || '--'}</PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>Email:</Label>
          <PixelDiv style={style}>{customerInfo?.email || '--'}</PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>CUSTOMER REFERENCE:</Label>
          <PixelDiv style={style}>
            {customerInfo?.business_reference_id || '--'}
          </PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>PHONE:</Label>
          <PixelDiv style={style}>{customerInfo?.phone || '--'}</PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>COMPANY:</Label>
          <PixelDiv style={style}>{customerInfo?.company || '--'}</PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>TOTAL ORDERS PLACED:</Label>
          <PixelDiv style={style}>{customerInfo?.orders_count || '0'}</PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>AMOUNT SPENT:</Label>
          <PixelDiv style={style}>
            {
              <PixelCurrency
                value={customerInfo?.total_order_amount}
                currency={'USD'}
              />
            }
          </PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>TOTAL PAYMENTS MADE:</Label>
          <PixelDiv style={style}>
            {
              <PixelCurrency
                value={customerInfo?.total_payment_amount}
                currency={'USD'}
              />
            }
          </PixelDiv>
        </InfoItem>
        <InfoItem>
          <Label>BALANCE:</Label>
          <PixelDiv style={style}>
            {<PixelCurrency value={customerInfo?.balance} currency={'USD'} />}
          </PixelDiv>
        </InfoItem>
        {tenant == 1 && (
          <InfoItem>
            <Label>Stripe ID:</Label>
            <PixelDiv style={style}>
              {customerInfo?.stripe_customer_id ? (
                customerInfo?.stripe_customer_id
              ) : (
                <PixelButton
                  variant="outline"
                  onClick={() => {
                    linkWithStripe()
                  }}
                  size="sm"
                >
                  Link With Stripe
                </PixelButton>
              )}
            </PixelDiv>
          </InfoItem>
        )}
      </PixelFlexBox>
    </>
  )
}

const InfoItem = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;

  &:last-child {
    border-bottom: none;
  }
`
const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #8e959b;
  display: table-cell;
  vertical-align: middle;
  padding-right: 10px;
  width: 50%;
`

export default GeneralInfo
